import React, { useState, useEffect } from "react";
import download1 from "../assets/memoryGameLevelTwoImg/download1.jpg";
import download2 from "../assets/memoryGameLevelTwoImg/download2.jpg";
import download3 from "../assets/memoryGameLevelTwoImg/download3.jpg";
import download4 from "../assets/memoryGameLevelTwoImg/download4.jpg";
import download5 from "../assets/memoryGameLevelTwoImg/download5.jpg";
import download6 from "../assets/memoryGameLevelTwoImg/download6.jpg";
import download7 from "../assets/memoryGameLevelTwoImg/download7.jpg";
import download8 from "../assets/memoryGameLevelTwoImg/download8.jpg";
import { toast } from "react-toastify";
import "../components/memorygame.css";
import { Link } from "react-router-dom";

function MemoryGameLevTwo() {
  const [items, setItems] = useState(
    [
      { id: 1, id2: 2, img: download1, stat: "" },
      { id: 2, id2: 1, img: download1, stat: "" },
      { id: 5, id2: 6, img: download2, stat: "" },
      { id: 6, id2: 5, img: download2, stat: "" },
      { id: 9, id2: 10, img: download3, stat: "" },
      { id: 10, id2: 9, img: download3, stat: "" },
      { id: 13, id2: 14, img: download4, stat: "" },
      { id: 14, id2: 13, img: download4, stat: "" },
      { id: 17, id2: 18, img: download5, stat: "" },
      { id: 18, id2: 17, img: download5, stat: "" },
      { id: 21, id2: 22, img: download6, stat: "" },
      { id: 22, id2: 21, img: download6, stat: "" },
      { id: 25, id2: 26, img: download7, stat: "" },
      { id: 26, id2: 25, img: download7, stat: "" },
      { id: 29, id2: 30, img: download8, stat: "" },
      { id: 30, id2: 29, img: download8, stat: "" },
    ].sort(() => Math.random() - 0.5)
  );
  const [prev, setPrev] = useState(-1);
  
  
  useEffect(() => {
    starttimer();
    return () => clearInterval(interv);
  }, []);
  
  
  
  function check(current) {
    if (items.stat !== "correct") {
      if (
        items[current].id === items[prev].id - 1 ||
        items[current].id2 === items[prev].id2 - 1
      ) {
        items[current].stat = "correct";
        items[prev].stat = "correct";
        setItems([...items]);
        setPrev(-1);
        const allCorrect = items.every((item) => item.stat === "correct");
        if (allCorrect) {
          toast.success("🦄 Won");
          setyourScore(time);
        }
      } else {
        items[current].stat = "wrong";
        items[prev].stat = "wrong";
        setItems([...items]);
        setTimeout(() => {
          items[current].stat = "";
          items[prev].stat = "";
          setItems([...items]);
          setPrev(-1);
        }, 1000);
      }
    }
  }

  function handleClick(id) {
    if (clickDisabled || items[id].stat === "correct") return;
    if (prev === -1 && items[id].stat !== "correct") {
      items[id].stat = "active";
      setItems([...items]);
      setPrev(id);
      setTimeout(() => {
        // Reset the active status after 2 seconds
        if (items[id].stat === "active") {
          items[id].stat = "";
          setItems([...items]);
        }
      }, 2000);
    } else if (items[id].stat !== "correct") {
      check(id);
      setClickDisabled(true); // Disable clicking after two cards are clicked
      setTimeout(() => {
        setClickDisabled(false); // Enable clicking after 0.5 seconds
      }, 1000);
    }
  }
  const resetButton = () => {
    window.location.reload(true);
    clearInterval(interv);
    setTime({ ms: 0, s: 0, m: 0 });
    starttimer();
  };

  //Stopwatch ------------------------------------------------------------------------

  const [time, setTime] = useState({ ms: 0, s: 0, m: 0 });
  const [interv, setInterv] = useState();
  const [yourScore, setyourScore] = useState({ ms: 0, s: 0, m: 0 });

  const [clickDisabled, setClickDisabled] = useState(false);

  const starttimer = () => {
    setInterv(setInterval(runTimer, 10));
  };

  const runTimer = () => {
    setTime((prevTime) => {
      let updatedMS = prevTime.ms + 1,
        updatedS = prevTime.s,
        updatedM = prevTime.m;
      if (updatedMS === 100) {
        updatedS++;
        updatedMS = 0;
      }
      if (updatedS === 60) {
        updatedM++;
        updatedS = 0;
      }
      return { ms: updatedMS, s: updatedS, m: updatedM };
    });
  };

  //Stopwatch ------------------------------------------------------------------------

  return (
    <>
      <div className="flex flex-col  justify-center items-center">
        <div className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2">
          <h1 className="text-[#FF008A]">Your score = </h1>
          <div className="mx-2">
            <h1>{yourScore.m >= 10 ? yourScore.m : "0" + yourScore.m}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{yourScore.s >= 10 ? yourScore.s : "0" + yourScore.s}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{yourScore.ms >= 10 ? yourScore.ms : "0" + yourScore.ms}</h1>
          </div>
        </div>
        <div className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2">
          <div className="mx-2">
            <h1>{time.m >= 10 ? time.m : "0" + time.m}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{time.s >= 10 ? time.s : "0" + time.s}</h1>
          </div>
          <p>:</p>
          <div className="mx-2">
            <h1>{time.ms >= 10 ? time.ms : "0" + time.ms}</h1>
          </div>
        </div>
        <div className="flex justify-center items-center m-2">
          <div className="lg:h-[500px] lg:w-[500px] w-[390px] h-[390px] grid grid-cols-4 grid-rows-4 lg:gap-2 gap-1">
            {items.map((item, index) => (
              <div
                key={index}
                className={"card" + (item.stat ? " active " + item.stat : "")}
                onClick={() => handleClick(index)}
              >
                <img src={item.img} alt="" />
              </div>
            ))}
          </div>
        </div>
        <button
          className="text-l bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2"
          onClick={resetButton}
        >
          Reset
        </button>
        <Link
          to="/"
          className="bg-[#00FF75] w-[250px] p-2 font-bold text-2x flex justify-center items-center rounded m-2"
        >
          Home
        </Link>
      </div>
    </>
  );
}

export default MemoryGameLevTwo;
